<template>
    <div class="row">
        <div class="col-md-3">
        <div class="card">
            <div class="card-bod">
            <div class="row">
                <div class="col-md-12 reports-div">
                <ul class="reports-outer">
                    <li class="report-list" :class="(slug == currentSummarySlug) ? 'active' : null" 
                        v-on:click="selectReport(slug,component)"
                        v-for="{name, slug, component} in summaryTypes" :key="name">
                        {{ name }}
                    </li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div class="col-md-9">
        <!-- Dynamic component rendering -->
            <component 
                :is="currentSummary" 
                :suppliers="suppliers"
                :tours="tours"
                :tourmanagers="tourmanagers"
                :affiliates="affiliates" 
                :advertise_sizes="advertise_sizes" 
            />
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import PaymentInvoices from '../components/Summary/PaymentInvoices.vue'
import ArtWorkListingSummary from '../components/Summary/ArtWorkListingSummary.vue'
import TourSummary from '../components/Summary/TourSummary.vue'

export default {
    name: 'SummariesIndex',
    components: {
        PaymentInvoices,
        ArtWorkListingSummary,
        TourSummary
    },
    data() {
        return {
            tours:[],
            summaryTypes: [
                {
                    name:'Payment Invoices',
                    slug:'payment_invoices',
                    component:'PaymentInvoices'
                },
                {
                    name:'Artwork',
                    slug:'artwork',
                    component:'ArtWorkListingSummary'
                },
                {
                    name:'Tour',
                    slug:'tour',
                    component:'TourSummary'
                },
            ],
            currentSummarySlug:'payment_invoices',
            currentSummary: 'PaymentInvoices',
            suppliers : [],
            tourmanagers: [],
            affiliates: [],
            advertise_sizes:[]
        }
    },
    created () {
        this.getFiltersData()
        this.getTours()
    },
    methods: {
        getTours()
        {
            axios.get(this.$api + 'tours',
            {
                headers:{
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then((response) => {
                this.tours = response.data.data
            });
        },
        selectReport(slug,comp) {
            this.currentSummarySlug = slug
            this.currentSummary = comp
        },
        getFiltersData() {
            // filters/get-pre-data
            fetch(this.$api + 'filters/get-pre-data', {
                method: 'POST',
                body: JSON.stringify({
                    filters_for: 'payment_invoices'
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.status) {
                    this.suppliers = response.data.suppliers
                    this.tourmanagers = response.data.tour_managers
                    this.affiliates = response.data.affiliates
                    this.advertise_sizes = response.data.advertise_sizes
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>

</style>